export const environment = {
  production: false,
  apiBaseUrl: 'https://localhost:7192',
  apiVersion: 'v1',
  googleRecaptchaSiteKey: ''
};
